import { render, staticRenderFns } from "./sitconfig.vue?vue&type=template&id=df56d7ce&scoped=true&"
import script from "./sitconfig.vue?vue&type=script&lang=js&"
export * from "./sitconfig.vue?vue&type=script&lang=js&"
import style0 from "./sitconfig.vue?vue&type=style&index=0&id=df56d7ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df56d7ce",
  null
  
)

export default component.exports